export default "__VITE_ASSET__BX47Z5sf__"